import { Card, Tag, Button, Modal } from 'antd'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { EyeOutlined } from '@ant-design/icons'
import { PLACEHOLDER_IMAGE } from 'config/Constants';
import VideoImagePreviewer from './VideoImagePreviewer';

const MediaSelectorCard = ({ url, isSelected = false, isMaxLimitReached = false, handleSelectMedia = () => { }, showPreviewIcon = false, tags = [] }) => {
    const { t } = useTranslation();
    const [isPreviewOpen, setIsPreviewOpen] = useState(false);

    const handlePreview = () => {
        setIsPreviewOpen(true);
    };

    const handleClosePreview = () => {
        setIsPreviewOpen(false);
    };

    return (
        <>
            <Card
                onClick={() => handleSelectMedia(url)}
                hoverable
                size="small"
                className={`w-full cursor-pointer ${!isSelected && isMaxLimitReached ? 'opacity-50 cursor-not-allowed' : ''}`}
                bodyStyle={{
                    padding: 0,
                    height: 0,
                    paddingBottom: '100%', // Creates square aspect ratio
                    position: 'relative',
                    border: isSelected ? '2px solid #52c41a' : '1px solid #d9d9d9',
                }}
            >
                {isSelected && (
                    <div className="absolute top-2 right-2 bg-green-500 text-white rounded-full w-6 h-6 flex items-center justify-center text-xs font-bold z-10">
                        ✓
                    </div>
                )}
                {showPreviewIcon && (
                    <div className="absolute top-2 left-2 z-10">
                        <Button
                            type="primary"
                            shape="circle"
                            size="small"
                            icon={<EyeOutlined />}
                            onClick={(e) => {
                                e.stopPropagation();
                                handlePreview();
                            }}
                            className="bg-blue-500 hover:bg-blue-600 border-blue-500 hover:border-blue-600"
                        />
                    </div>
                )}
                {!isSelected && isMaxLimitReached && (
                    <div className="absolute inset-0 bg-gray-900 bg-opacity-50 flex items-center justify-center z-10">
                        <div className="bg-white px-2 py-1 rounded text-xs text-gray-700">
                            {t("Max limit reached")}
                        </div>
                    </div>
                )}
                <div className={`absolute inset-1 flex items-center justify-center ${isSelected ? 'opacity-90' : 'opacity-100'}`}>
                    <VideoImagePreviewer url={url || PLACEHOLDER_IMAGE} />
                </div>
                {tags?.length > 0 && <div className='absolute bottom-0 left-0 right-0 p-2 flex flex-wrap gap-2 backdrop-blur-md'
                >
                    {tags?.map((tag, index) => (
                        <Tag key={index} color="green" className='text-xs'>{tag}</Tag>
                    ))}
                </div>
                }
            </Card>

            {isPreviewOpen && <Modal
                open={isPreviewOpen}
                onCancel={handleClosePreview}
                footer={null}
                width={800}
                centered
                title={t("Media Preview")}
            >
                <div className="flex justify-center">
                    <VideoImagePreviewer 
                        url={url || PLACEHOLDER_IMAGE} 
                        autoplay={true}
                        muted={!isPreviewOpen}
                    />
                </div>
            </Modal>}
        </>
    )
}

export default MediaSelectorCard